import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

import { baseQueryWithReauth } from "../setup";

// Define a service using a base URL and expected endpoints
export const userApi = createApi({
  reducerPath: "userApi",
  baseQuery: baseQueryWithReauth,
  tagTypes: ["Users", "DeletedUsers"],
  endpoints: (builder) => ({
    getUserList: builder.query({
      query: (organizationSubDomain) => {
        return {
          url: `/user/list`,
          method: "GET",
          params: { subdomain: organizationSubDomain },
        };
      },
      providesTags: (result) => {
        return result
          ? [
              ...result.map(({ id }) => ({ type: "Users", id })),
              { type: "Users", id: "LIST" },
            ]
          : [{ type: "Users", id: "LIST" }];
      },
    }),
    createUser: builder.mutation({
      query: ({ subdomain, payload }) => {
        return {
          url: `/user/create`,
          method: "POST",
          body: { ...payload },
          params: { subdomain },
        };
      },
      invalidatesTags: [{ type: "Users", id: "LIST" }],
    }),
    updateUser: builder.mutation({
      query: ({ subdomain, id, payload }) => {
        return {
          url: `/user/${id}`,
          method: "PATCH",
          body: payload,
          params: { subdomain },
        };
      },
      invalidatesTags: [{ type: "Users", id: "LIST" }],
    }),
    updateUserPassword: builder.mutation({
      query: ({subdomain, payload}) => {
        return {
          url: `/user/update-password`,
          method: "POST",
          body: payload,
          params: { subdomain }
        }
      },
      invalidatesTags: [{ type: "Users", id: "LIST" }],
    }),
    updateUserState: builder.mutation({
      query: ({ subdomain, payload, id }) => {
        return {
          url: `/user/${id}/state`,
          method: "PATCH",
          body: payload,
          params: { subdomain },
        }
      },
      invalidatesTags: [{ type: "Users", id: "LIST" }],
    }),
    deleteUser: builder.mutation({
      query: ({ subdomain, id }) => {
        return {
          url: `/user/${id}`,
          method: "DELETE",
          params: { subdomain },
        };
      },
      invalidatesTags: [{ type: "Users", id: "LIST" }],
    }),
    getMe: builder.query({
      query: () => {
        return {
          url: `auth/user`,
          method: "GET",
        };
      },
      providesTags: [{ type: "Profile", id: "Profile" }],
    }),
	  getDeletedUserList: builder.query({
		  query: (organizationSubDomain) => {
			  return {
				  url: `/user/deleted`,
				  method: "GET",
				  params: { subdomain: organizationSubDomain },
			  };
		  },
		  providesTags: (result) => {
			  return result
				  ? [
					  ...result.map(({ id }) => ({ type: "DeletedUsers", id })),
					  { type: "DeletedUsers", id: "LIST" },
				  ]
				  : [{ type: "DeletedUsers", id: "LIST" }];
		  },
	  }),
	  recoverUser: builder.mutation({
		  query: ({ subdomain, id }) => {
			  return {
				  url: `/user/recover/${id}`,
				  method: "PATCH",
				  params: { subdomain },
			  }
		  },
		  invalidatesTags: [{ type: "Users", id: "LIST" }],
	  }),
	  permanentlyDeleteUser: builder.mutation({
		  query: ({ subdomain, id }) => {
			  return {
				  url: `/user/permanently/${id}`,
				  method: "DELETE",
				  params: { subdomain },
			  }
		  }
	  }),
  }),
});

export const {
  useLazyGetUserListQuery,
  useGetUserListQuery,
  useUpdateUserMutation,
  useUpdateUserPasswordMutation,
  useUpdateUserStateMutation,
  useCreateUserMutation,
  useDeleteUserMutation,
  useLazyGetMeQuery,
  useGetMeQuery,
	useLazyGetDeletedUserListQuery,
	useRecoverUserMutation,
	usePermanentlyDeleteUserMutation,
} = userApi;
